module.exports = __webpack_public_path__ + "img/建筑幕墙工程专业承包一级.a8964faf.png";